import { BoardCardType } from "@fry/boards/lib";
import { UserAvailableCardViewComponent } from "./user-available-card.view.component";
import { TitleCardSettingsComponent } from "@fry/dashboards/components/card-title-settings/title-card.settings.component";

export const UserAvailableCard: BoardCardType = {
    name: 'user-available',
    title: $localize `Available bookings`,
    viewComponent: UserAvailableCardViewComponent,
    editComponent: TitleCardSettingsComponent,
}
